
export const filters = {


    getColorByRate(rate) {

        let color = "";

        switch (true) {
            case (rate >= 0 && rate <= 35):
                color = "red";
                break
            case (rate >= 36 && rate <= 55):
                color = "orange";
                break;

            case rate >= 56 && rate <= 65:
                color = "yellow";
                break;

            case rate >= 66 && rate <= 100:
                color = "green";
                break;
        }

        return color;
    },


    getProfileColor(value) {

        let letter = value.toLowerCase()
        let color = "";

        switch (letter) {
            case ('a'):
            case ('b'):
            case ('c'):
            case ('d'):
            case ('e'):
            case ('f'):
                color = "red";
                break

            case ('g'):
            case ('h'):
            case ('i'):
            case ('j'):
            case ('k'):
            case ('l'):
                color = "green";
                break

            case ('m'):
            case ('n'):
            case ('o'):
            case ('p'):
            case ('q'):
            case ('r'):
                color = "blue";
                break

            case ('s'):
            case ('t'):
            case ('u'):
            case ('v'):
            case ('w'):
            case ('x'):
            case ('y'):
            case ('z'):
                color = "blue";
                break


        }

        return color;
    },



    stringTrim(text, length = 25) {
        if (text.length > length) {
            return text.substring(0, length) + '...';
        }
        return text;
    }



}